import React, { useEffect, useState } from 'react';
import { Dialog, IconButton, DialogTitle, DialogContent, DialogActions, Button, Divider } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { CheckBox, NumberBox, TagBox, TextArea } from 'devextreme-react';
import { TextBox } from 'devextreme-react/text-box';
import saveIconWhite from '../../images/save-icon-white.svg';
import genericAddIcon from "../../images/add-icon-white.svg"
import SelectBox from "../common/CustomSelectBox";
import { QUERY_GET_BRANDS, QUERY_GET_MASTER_CUSTOMERS, QUERY_GET_MODELSBYBRANDID } from '../../fetch/constantQueries';
import { useDispatch } from 'react-redux';
import { baseRequest } from '../../fetch/basicThunk';

function InputWrapper(props) {
  const { classes, label } = props;
  return (
    <div className="input-admin">
      <label className={classes?.label}>{label}</label>
      <div style={{ width: '75%' }} className="dx-field-value">
        {props.children}
      </div>
    </div>
  );
}

function NewContractDialog(props) {
  const { editMode, operation, title, open, onClose, handleOnClick, dialogSize, dataForm, onChange, onOperationChange } = props;
  const [phoneMask, setPhoneMask] = useState('+00 (00) 0000-0000');
  const dispatch = useDispatch();

  const handleMaskChange = (e) => {
    const value = e.value || '';
    if (value.startsWith('+')) {
      setPhoneMask('+00 (00) 0000-0000'); // International format
    } else {
      setPhoneMask('(00) 0000-0000'); // Local format
    }
  };

  const dialogStyles = {
    // width: operation !== 'delete' ? (dialogSize?.width || '550px') : '550px',
    // height: operation !== 'delete' ? (dialogSize?.height || '180px') : '180px',
    width: '550px',
    height: '100%',
    minWidth: 'max-content',
  };

  const buttonStyles = {
    padding: '6px 16px',
    fontSize: '13px',
    margin: 'auto',
    marginTop: '5px',
    borderRadius: '0',
    color: 'white',
    backgroundColor: '#3B5158',
  };

  const buttonSaveStyles = {
    padding: '6px 16px',
    fontSize: '13px',
    marginRight: '16px',
    marginTop: '5px',
    float: 'right',
    borderRadius: '0',
    color: 'white',
    backgroundColor: '#3B5158',
  };

  const closeButton = {
    position: 'absolute',
    right: '6px',
    top: '0px',
  };


  const [customers, setCustomer] = useState();
  const [brands, setBrands] = useState();
  const [modelsFiltered, setModelsFiltered] = useState();

  useEffect(()=>{
      fetchCustomers();
      fetchBrands();
  },[])

  async function fetchCustomers(){
      const customers = await baseRequest({}, dispatch, QUERY_GET_MASTER_CUSTOMERS, "GET");
      setCustomer(customers);
  }

  async function fetchBrands(){
      const brands = await baseRequest({}, dispatch, QUERY_GET_BRANDS, "GET");
      setBrands(brands);
  }

  function onBrandChange(value){
    onChange('brandId', value)
    if(value != null || value != undefined){
      fetchModelsByBrandID(value);
    }
    else{
      setModelsFiltered(null)
    }
  }

  async function fetchModelsByBrandID(brandId){
      const models = await baseRequest({param: brandId}, dispatch, QUERY_GET_MODELSBYBRANDID, "GET");
      setModelsFiltered(models);
  } 

  return (
    <Dialog maxWidth={'xl'} open={open} onClose={onClose} style={{ borderRadius: 0 }}>
      <div style={dialogStyles}>
        <DialogTitle disableTypography className="titleStyles">
          {title}
          {/* {operation !== 'delete' && <IconButton onClick = {onClose} style = {closeButton}> <Close style={{color: "white"}}/> </IconButton>} */}
          <IconButton onClick={onClose} style={closeButton}>
            <Close />
          </IconButton>
        </DialogTitle>
        <hr class="MuiDivider-root" style={{ width: '100%', backgroundColor: 'black' }}></hr>

        <DialogContent style={{padding: "12px 24px"}}>

          {(operation === 'add' || operation === 'changeCustomer') && (
            <>
              <span>Cliente</span>
              <SelectBox
                label={"Customer"}
                name="Customer"
                dataSource={customers}
                showClearButton={true}
                // acceptCustomValue
                // onCustomItemCreating={customItemCreating}
                value={dataForm?.customerId}
                //displayExpr={"cpf"}
                displayExpr={(item) => item == null ? null :  `${item?.cpf} - ${item?.customerName}`} 
                valueExpr={"customerId"}
                onValueChanged={(e) => onChange('customerId', e.value)}
                searchEnabled={true}
              ></SelectBox>
            </>
          )}

          <div style={{ display: 'flex', flexFlow: 'column', rowGap: '1rem' }}>

          {operation === 'add' && (
              <>
                <Divider></Divider>
                <span>Veículo</span>

                <SelectBox
                  label={"Marca"}
                  name="Marca"
                  dataSource={brands}
                  showClearButton={true}
                  // acceptCustomValue
                  // onCustomItemCreating={customItemCreating}
                  value={dataForm?.brandId}
                  displayExpr={"brandName"}
                  valueExpr={"brandId"}
                  onValueChanged={(e) => onBrandChange(e.value)}
                  searchEnabled={true}
                ></SelectBox>

                <SelectBox
                  label={"Modelo"}
                  name="Modelo"
                  dataSource={modelsFiltered}
                  showClearButton={true}
                  // acceptCustomValue
                  // onCustomItemCreating={customItemCreating}
                  value={dataForm?.modelId}
                  displayExpr={"modelName"}
                  valueExpr={"modelId"}
                  onValueChanged={(e) => onChange('modelId', e.value)}
                  searchEnabled={true}
                  disabled={modelsFiltered == null || modelsFiltered == undefined || modelsFiltered == []}
                ></SelectBox>

                {/* <TextBox
                  label={'CPF*'}
                  key={'CPF'}
                  //disabled={editMode}
                  name="CPF"
                  mask="000.000.000-00"
                  placeholder="000.000.000-00"
                  showMaskMode="onFocus"
                  maskRules={{ 0: /[0-9]/ }}
                  value={dataForm?.CPF}
                  onValueChanged={(e) => onChange('CPF', e.value)}
                ></TextBox> */}

                <TextBox label={'Ano/Modelo'} key={'Year'} name="Year" value={dataForm?.year} onValueChanged={(e) => onChange('year', e.value)}></TextBox>
                <TextBox label={'Placa'} key={'Placa'} name="Placa" value={dataForm?.plate} onValueChanged={(e) => onChange('plate', e.value)}></TextBox>
                <TextBox label={'Cor'} key={'Cor'} name="Cor" value={dataForm?.color} onValueChanged={(e) => onChange('color', e.value)}></TextBox>
                <TextBox label={'Chassi'} key={'Chassi'} name="Chassi" value={dataForm?.chassis} onValueChanged={(e) => onChange('chassis', e.value)}></TextBox>
              </>
            )}

            {operation === 'confirm' && (
              <span>Placa não encontrada, deseja cadastrar este veículo?</span>
            )}
            </div>

          
        </DialogContent>
        <DialogActions style={{padding: "12px 24px"}}>
          <div style={{ display: 'flex', gap: '1rem', paddingRight: 16 }}>
            {operation === 'add' || operation === 'changeCustomer' ? (
              <>
                <Button variant="contained" onClick={onClose}>
                  Cancelar
                </Button>

                <Button variant="contained" color="primary" onClick={handleOnClick} startIcon={<img src={saveIconWhite} />}>
                  Salvar
                </Button>
              </>
            ) : (
             <>
                <Button variant="contained" onClick={onClose}>
                  Não
                </Button>

                <Button variant="contained" color="primary" onClick={() => onOperationChange(operation)} startIcon={<img src={genericAddIcon} />}>
                  Sim
                </Button>
              </>
            )}
          </div>
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default NewContractDialog;
